module.exports = __webpack_public_path__ + "baaa9bdc8717dfe86735b319fb57a242.fbx";